import moment from "moment";

const API_HOST = process.env.REACT_APP_API_HOST_URL;

const saveFile = async (blob, type) => {
  const a = document.createElement("a");
  const date = moment().format("YYYYMMDD");
  a.download = `recall-list_${date}.${type}`;
  a.href = URL.createObjectURL(blob);
  a.addEventListener("click", () => {
    setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
  });
  a.click();
};

export const exportRecallList = async ({ ...parameters }) => {
  let response = await fetch(
    `${API_HOST}/distributor/admin/export/v1/recall-export?token=${parameters.token}`,

    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${parameters.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        search: parameters.search,
        nodeIds: parameters.nodeIds,
        fromDate: parameters.fromDate,
        toDate: parameters.toDate,
        recallFrom: parameters.recallFrom,
        recallBy: parameters.recallBy,
        fileType: parameters.fileType,
        customFields: parameters.customFields,
        order: parameters.order,
        orderBy: parameters.orderBy,
      }),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Export failed");
  }

  const blob = await response.blob();
  saveFile(blob, parameters.fileType);
};
